import { useEffect, useState } from "react";
import { getParsicUser, getPersonnelVoips, getVoipReports, getVoipToken, setVoipReports } from "../../../api/api"
import { UpdateParsicUsers } from "../../../redux/reducers/parsicUsersSlice"
import { useAppDispatch, useAppSelector } from "../../../redux/store/storehooks";
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from "../../../services/toast.notification";
import { Button, Checkbox, Col, ConfigProvider, Modal, Radio, RadioChangeEvent, Row, Space } from "antd";
import jalali_moment from 'jalali-moment';
import CustomTable from "../../../components/_common/Table";
import { ColumnsType } from "antd/lib/table";
import { DatePicker as DatePickerJalali, JalaliLocaleListener, useJalaliLocaleListener } from "antd-jalali";
import moment from 'moment'
import fa_IR from "antd/lib/locale/fa_IR";
import "./style.css";
import Spinner from "../../../components/_common/Spinner";
import CustomSelect from "../../../components/_common/CustomSelect";
import CustomTextArea from "../../../components/_common/CustomTextArea";
import * as XLSX from "xlsx";

export interface InputProps {
    labId: any
}

const PersonnelVoipManagement = ({ labId }: InputProps) => {
    const columns: ColumnsType<any> = [
        { title: 'آزمایشگاه ', dataIndex: 'customername', key: 'customername' },
        { title: 'شماره آزمایشگاه', dataIndex: 'callernumber', key: 'callernumber' },
        { title: 'شماره هدف ', dataIndex: 'targetnumber', key: 'targetnumber' },
        { title: 'تعداد ارجاع', dataIndex: 'DivertCount', key: 'DivertCount' },
        { title: 'تاریخ تماس', dataIndex: 'calldate', key: 'calldate' },
        { title: 'ساعت تماس', dataIndex: 'calltime', key: 'calltime' },
        { title: 'شخص', dataIndex: 'exten', key: 'exten' },
        { title: 'ارجاع', dataIndex: 'DivertRoute', key: 'DivertRoute' },
        {
            title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Space size="middle">
                    <a
                        href={"https://192.168.1.10/" + record.recordingfile}
                        download="Example-PDF-document"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button type="primary" style={{ backgroundColor: "#00b7ff" }}
                            disabled={!permission} >دانلود فایل</Button>
                    </a>
                    <Button type="primary" style={{ backgroundColor: "orange" }}
                        onClick={() =>
                            OpenModal(record)}>  گزارش</Button>
                </Space>


            )
        }
    ];

    const [isLoading, setIsLoading] = useState(true);
    const [permission, setPermission] = useState(false);
    const [userList, setUserList] = useState<any[]>([]);
    const [radioVal, setRadioVal] = useState(0);
    const [voipLogs, setVoipLogs] = useState([]);
    const [firstDate, setFirstDate] = useState<any>(undefined);
    const [lastDate, setLastDate] = useState<any>(undefined);
    const [selectedExten, setSelectedExten] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [voipReport, setVoipReport] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState<any>(undefined);
    const [isSolve, setIsSolve] = useState(false);
    const [isReferral, setIsReferral] = useState(false);
    const [isCallAgain, setIsCallAgain] = useState(false);
    const [isConfirms, setIsConfirms] = useState(false);
    const [reportList, setreportList] = useState<any[]>([]);
    const [isManager, setIsManager] = useState(false);
    const [error, setError] = useState("");
    const [inProgress, setInProgress] = useState(false);
    const [voipRecordedCount, setVoipRecordedCount] = useState(0);

    const [inputValues, setInputValue] = useState({
        id: 0,
        mode: 0,
        problems: "",
        solve: true,
        type: 0,
        confirms: true,
        desc: "",
        userId: 0,
        callNumber: "",
        durationPerformance: '',
        referral: true,
        strreferral: "",
        callAgain: true,
        labId: 0,
        reciver: '',
        referralScore: '',
        score: '',
        callDate: ""
    });

    const problemTypes = [
        {
            title: "سنترال",
            value: 1
        },
        {
            title: "وب و شبکه",
            value: 2
        },
        {
            title: "ژورنال و دستگاه",
            value: 3
        },
        {
            title: "سایر",
            value: 4
        }]

    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();

    const _getParsicUser = () => {
        setIsLoading(true);
        getParsicUser()
            .then((result: any) => {
                dispatch(UpdateParsicUsers({ parsicUsers: result.data.data }))
                setUserList(result.data.data)
                setSelectedExten(result.data.data[0].int_VoipExtension);

                setIsLoading(false);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })
    }

    const _getPersonnelVoips = (fdate: any, ldate: any, exten: any) => {
        setIsLoading(true);
        //getVoipToken()
        // .then((result) => {
        getPersonnelVoips(labId, exten, fdate, ldate)
            .then((result: any) => {
                if (result.data.data != "") {
                    let jsonResult = JSON.parse(result.data.data);
                    let newList: any = [];
                    jsonResult.map((item: any) => {
                        //let index: number = result.data.findIndex((x: { int_VoipExtension: any; }) => x.int_VoipExtension == item.exten);
                        let obj: any = myStore.parsicUsers.list.find((x: any) => x.int_VoipExtension == Number(item.exten));
                        let FullName: string = obj !== undefined ? obj.str_FullName : "";
                        newList.push(
                            {
                                rowid: item.rowid,
                                customername: item.customername,
                                callernumber: item.callernumber,
                                labid: item.labid,
                                calldate: jalali_moment(item.calldate).locale("fa").format("YYYY-MM-DD"),
                                calltime: item.calltime,
                                targetnumber: item.targetnumber,
                                billsec: item.billsec,
                                sumsec: item.sumsec,
                                exten: FullName,
                                extenNum: item.exten,
                                DivertCount: item.DivertCount,
                                DivertRoute: item.DivertRoute,
                                UNIQUEID: item.UNIQUEID,
                                recordingfile: item.recordingfile
                            }
                        )
                    })
                    setVoipLogs(newList);
                }
                else {
                    setVoipLogs([]);
                }


                setIsLoading(false);
                console.log(result.data);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(true);

                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

        // })
        // .catch((error) => {
        //     console.log(error);
        //     errorNotify(error.response.data.errorMessage, undefined, 5000)
        // })
    }

    const onChangeRadio = (e: RadioChangeEvent) => {
        // console.log('radio checked', e.target.value);
        setIsLoading(true);
        setRadioVal(e.target.value);
        _getPersonnelVoips(firstDate != undefined ? jalali_moment.from(firstDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), lastDate != undefined ? jalali_moment.from(lastDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
                .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), e.target.value);
        setSelectedExten(e.target.value);
        //_getUserMessages(e.target.value);
    }

    const onChangeDatePicker = (dates: any, dateStrings: any, info: any) => {

        console.log(dates);
        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        setFirstDate(dates[0])
        setLastDate(dates[1])

        let fdate = jalali_moment.from(dates[0].format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD');
        let ldate = jalali_moment.from(dates[1].format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD');


        _getPersonnelVoips(fdate, ldate, selectedExten);
        //ExcelTaxInfo(dates[0].format('YYYY-MM-DD'),dates[1].format('YYYY-MM-DD'));

    }

    const _setNewVoipVReport = () => {
        setIsLoading(true);
        addNewReport();
        _clearForm();
    }

    const addNewReport = () => {
        let obj: any = myStore.parsicUsers.list.find((x: any) => x.int_VoipExtension == Number(selectedRecord.extenNum));
        let newReport: any =
        {
            "id": 0,
            "mode": 0,
            "problems": inputValues.problems,
            "solve": isSolve,
            "type": inputValues.type ? Number(inputValues.type) : 1,
            "confirms": isConfirms,
            "desc": inputValues.desc,
            "userId": obj.prk_ParsicUser_AutoID,
            "callNumber": selectedRecord.callernumber,
            "durationPerformance": inputValues.durationPerformance != "" ? Number(inputValues.durationPerformance) : 0,
            "referral": isReferral,
            "strreferral": inputValues.strreferral,
            "callAgain": isCallAgain,
            "labId": Number(selectedRecord.labid),
            "reciver": inputValues.reciver ? Number(inputValues.reciver) : 0,
            "referralScore": inputValues.referralScore != "" ? inputValues.referralScore : 0,
            "score": inputValues.score != "" ? inputValues.score : 0,
            "callDate": jalali_moment.from(selectedRecord.calldate, 'fa', 'YYYY/M/D').format('YYYY/M/D')
        };
        // setreportList(prevItems => [...prevItems, newReport]); // Create a new array and update state
        const updatedList = [...reportList, newReport];
        setreportList(updatedList);
        return updatedList;
        //sendToApi(updatedList);
        // setreportList([...reportList, newReport]);
    }

    const _setVoipVReport = () => {
        setInProgress(true);
        var updatedList = addNewReport();
        setVoipReports(updatedList)
            .then((result: any) => {
                setIsLoading(false);
                CloseModal();
                sucessNotify("ثبت شد");
                setInProgress(false);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            });
    }

    const _clearForm = () => {
        setIsSolve(false);
        inputValues.type = 1;
        setIsConfirms(false);
        setIsReferral(false);
        setIsCallAgain(false);
        setInputValue({
            id: 0,
            mode: 0,
            problems: "",
            solve: true,
            type: 0,
            confirms: true,
            desc: "",
            userId: 0,
            callNumber: "",
            durationPerformance: '',
            referral: true,
            strreferral: "",
            callAgain: true,
            labId: 0,
            reciver: '',
            referralScore: '',
            score: '',
            callDate: ""
        })


    }

    const _getVoipVReport = (record: any) => {
        let obj: any = myStore.parsicUsers.list.find((x: any) => x.int_VoipExtension == Number(record.extenNum));

        setIsLoading(true);

        let fDate = jalali_moment.from(record.calldate, 'fa', 'YYYY/M/D').format('YYYY/M/D');
        let ldate = jalali_moment.from(record.calldate, 'fa', 'YYYY/M/D').format('YYYY/M/D');
        getVoipReports(Number(record.labid), obj.prk_ParsicUser_AutoID, fDate, ldate)
            .then((result: any) => {
                let voipList = result.data.data
                setVoipRecordedCount(voipList.length)
                setIsLoading(false)
            });
    }

    const CloseModal = () => {
        setShowModal(false);
    }

    const OpenModal = (record: any) => {
        _clearForm();
        setreportList([]);
        setSelectedRecord(record);
        setShowModal(true);
        setError("");
        _getVoipVReport(record)
    }

    const handleChange = (event: any) => {
        if (event.target.name == 'isSolve') {
            if (event.target.checked) {
                setIsSolve(event.target.checked);
            }
            else {
                setIsSolve(false);
            }
        }

        if (event.target.name == 'isReferral') {
            if (event.target.checked) {
                setIsReferral(event.target.checked);
            }
            else {
                setIsReferral(false);
            }
        }

        if (event.target.name == 'isCallAgain') {
            if (event.target.checked) {
                setIsCallAgain(event.target.checked);
            }
            else {
                setIsCallAgain(false);
            }
        }
        if (event.target.name == 'isConfirms') {
            if (event.target.checked) {
                setIsConfirms(event.target.checked);
            }
            else {
                setIsConfirms(false);
            }
        }
        else {

            const { name, value } = event.target;

            if (name == "durationPerformance") {
                if (value === "" || value.match(/^[0-9]+$/ig)) {
                    setError("");
                    setInputValue(prev => ({
                        ...prev,
                        [name]: event.target.value
                    }))
                } else {
                    setError("فقط عدد مجاز است");
                }
            }
            else {

                setInputValue(prev => ({
                    ...prev,
                    [name]: event.target.value
                }))
            }
        }
    }
    const DownloadExcel = () => {
        getPersonnelVoips(labId, selectedExten, firstDate != undefined ? jalali_moment.from(firstDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), lastDate != undefined ? jalali_moment.from(lastDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
                .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"))
            .then((result: any) => {

                if (result.data.data != "") {
                    let calls = JSON.parse(result.data.data);
                    const grouped = calls.reduce((acc: any, item: any) => {
                        const key = item.exten?.trim();
                        if (!key) return acc; // حذف نامشخص‌ها
                        acc[key] = (acc[key] || 0) + 1;
                        return acc;
                    }, {});


                    const callStats = Object.entries(grouped).map(([exten, count]) => {
                        const match = myStore.parsicUsers.list.find((e: any) => e.int_VoipExtension === Number(exten));

                        if (!match || !match.str_FullName?.trim()) return null; // فقط اگه نام داره
                        return {
                            exten,
                            name: match.str_FullName,
                            count,
                        };
                    }).filter(Boolean);

                    let obj: any = myStore.parsicUsers.list.find((x: any) => x.int_VoipExtension == Number(selectedExten));
                    getVoipReports(labId, obj.prk_ParsicUser_AutoID, firstDate != undefined ? jalali_moment.from(firstDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
                        .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), lastDate != undefined ? jalali_moment.from(lastDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
                            .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"))
                        .then((result: any) => {
                            if (result.data.data.length > 0) {
                                const problems = result.data.data;
                                const problemStats = problems.reduce((acc: any, item: any) => {
                                    const key = item.responsive?.trim();
                                    if (!key) return acc; // حذف نامشخص‌ها
                                    if (!acc[key]) {
                                        acc[key] = { total: 0, solved: 0, unsolved: 0 };
                                    }
                                    acc[key].total += 1;
                                    if (item.bit_Solved) acc[key].solved += 1;
                                    else acc[key].unsolved += 1;

                                    return acc;
                                }, {});
                                const finalData = callStats.map(item => {
                                    const stat = problemStats[item!.name?.trim()] || { total: 0, solved: 0, unsolved: 0 };
                                    return {
                                        "نام": item!.name,
                                        "کل تماس": item!.count,
                                        "کل ثبت شده": stat.total,
                                        "کل حل شده": stat.solved,
                                        "کل حل نشده": stat.unsolved,
                                    };
                                });

                                const ws = XLSX.utils.json_to_sheet(finalData);
                                const wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, ws, "گزارش تماس‌ها");

                                // ساخت فایل و دانلود در مرورگر
                                XLSX.writeFile(wb, "ViopReport.xlsx");
                            }
                            setIsLoading(false)
                        });
                }
                else errorNotify("داده ای جهت خروجی وجود ندارد");

            })
    }

    useEffect(() => {
        if (myStore.auth.loginType === 'parsicuser') {
            myStore.auth.permission.map((item: any) => {
                if (item.pageName == 'voipManagement' && item.isDetailAccess)
                    setPermission(true);
            });
        }

        _getParsicUser();

    }, []);

    return (<>
        <Row>

        </Row>
        {
            isLoading === false && (

                <Row>
                    <Col lg={6} md={6} sm={24} xs={24}>
                        <div className="col-shadow">
                            <Radio.Group
                                style={{ marginTop: '15px' }}
                                onChange={onChangeRadio} value={radioVal}>
                                {myStore.parsicUsers.list && myStore.parsicUsers.list.map((item: any) => {
                                    if (item.int_VoipExtension != 0) {
                                        return (
                                            <div>
                                                <Radio value={item.int_VoipExtension}>{item.str_FullName}</Radio>
                                            </div>)
                                    }
                                })}
                            </Radio.Group>
                        </div>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                        <div className="viop-content">

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                                <div className="calender">
                                    <ConfigProvider locale={fa_IR} direction="rtl">
                                        <JalaliLocaleListener />
                                        <DatePickerJalali.RangePicker
                                            value={[firstDate, lastDate]}
                                            onCalendarChange={(dates: any, dateStrings: any, info: any) =>
                                                onChangeDatePicker(dates, dateStrings, info)
                                            }
                                        />
                                    </ConfigProvider>
                                </div>
                                {voipLogs.length > 0 && (
                                    <button className="excel-btn" onClick={DownloadExcel}>
                                        📊 فایل اکسل گزارش تماس‌ها
                                    </button>
                                )
                                }

                            </div>

                            <Row>

                                <CustomTable columns={columns} data={voipLogs} isloading={isLoading}
                                    permission={permission} />
                            </Row>
                        </div>
                    </Col>

                </Row>
            )
        }
        {
            isLoading === true && (
                <Spinner />
            )
        }

        {showModal && (
            <div className="personnel-modal-backdrop">
                <div className="personnel-modal-content">
                    <div className="personnel-modal-header">
                        <h5 style={{ fontSize: '20px' }}>ثبت گزارش جدید</h5>
                        <button onClick={CloseModal} className="personnel-close-button">&times;</button>
                    </div>
                    <div className="personnel-modal-body">
                        {voipRecordedCount > 0 && (<Row className="voip-info">
                            برای این رکورد قبلاً{' '}
                            <span className="count"> {voipRecordedCount} </span> گزارش ثبت شده است.
                        </Row>)}
                        <Row>
                            <Col lg={12} md={12} sm={24} xs={24}>

                                <CustomSelect
                                    name="type"
                                    placeholder="دسته بندی"
                                    itemList={problemTypes}
                                    value={inputValues.type.toString() || ""}
                                    onChange={(e) => handleChange(e)}
                                    valueObjectField={"value"}
                                    displayObjectField={"title"}
                                />
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>

                                <CustomTextArea
                                    name="durationPerformance"
                                    placeholder="مدت زمان حل مشکل"
                                    value={inputValues.durationPerformance.toString() || ""}
                                    onChange={handleChange}
                                />
                                {error && <span style={{ color: 'red' }} className="text-red-500 text-sm">{error}</span>}
                            </Col>
                        </Row>
                        <Row>
                            <CustomTextArea
                                name="problems"
                                placeholder="توضیحات مشکل پیش آمده"
                                value={inputValues.problems || ""}
                                onChange={handleChange}
                            />
                        </Row>

                        <Row style={{ margin: '15px 0px' }}>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <Checkbox
                                    name="isSolve"
                                    onChange={(e) => handleChange(e)}
                                    checked={isSolve}
                                >
                                    {"مشکل حل شد"}
                                </Checkbox>

                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <Checkbox
                                    name="isReferral"
                                    onChange={(e) => handleChange(e)}
                                    checked={isReferral}
                                >
                                    {"ارجاع"}
                                </Checkbox>
                            </Col>
                        </Row>
                        {isReferral &&
                            <Row>
                                <Col lg={12} md={12} sm={24} xs={24}>

                                    <CustomSelect
                                        name="reciver"
                                        placeholder="ارجاع به"
                                        itemList={myStore.parsicUsers.list}
                                        value={inputValues.reciver}
                                        onChange={(e) => handleChange(e)}

                                        valueObjectField={"prk_ParsicUser_AutoID"}
                                        displayObjectField={"str_FullName"}
                                    />
                                </Col>
                                <Col lg={12} md={12} sm={24} xs={24}>

                                    <CustomTextArea
                                        name="strreferral"
                                        placeholder="دلیل ارجاع"
                                        value={inputValues.strreferral || ""}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <CustomTextArea
                                    name="score"
                                    disabled={true}
                                    placeholder="امتیاز"
                                    value={inputValues.score || ""}
                                    onChange={handleChange}
                                />
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <CustomTextArea
                                    name="referralScore"
                                    disabled={true}
                                    placeholder="امتیاز ارجاع"
                                    value={inputValues.referralScore || ""}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Row>
                        <Row style={{ margin: '15px 0px' }}>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <Checkbox
                                    name="isCallAgain"
                                    onChange={(e) => handleChange(e)}
                                    checked={isCallAgain}
                                >
                                    {"نیاز به تماس مجدد"}
                                </Checkbox>
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <Checkbox
                                    name="isConfirms"
                                    disabled={true}
                                    onChange={(e) => handleChange(e)}
                                    checked={isConfirms}
                                >
                                    {"تایید شد"}
                                </Checkbox>
                            </Col>
                        </Row>
                        {isCallAgain && <Row>
                            <CustomTextArea
                                name="desc"
                                placeholder="توضیحات اضافی"
                                value={inputValues.desc}
                                onChange={(e) => setInputValue(prev => ({
                                    ...prev,
                                    desc: e.target.value
                                }))}
                            />
                        </Row>
                        }
                    </div>
               
                        <div className="personnel-modal-footer">
                            <button
                                className="btn btn-success"
                                onClick={_setVoipVReport}
                                disabled={inProgress}
                            >
                                {inProgress ? (
                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                        در حال ثبت...
                                    </>
                                ) : (
                                    'ثبت'
                                )}
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={_setNewVoipVReport}
                                disabled={inProgress}
                            > جدید  </button>

                            <button
                                className="btn btn-danger"
                                onClick={CloseModal}
                                disabled={inProgress}
                            >
                                انصراف </button>
                        </div>

                    </div>
                </div>
        )}
    </>)
}

export default PersonnelVoipManagement;